import { REGEXPS } from 'constants/regexps';

/** Убирает почтовый индекс из начала адреса */
export const removeZipCodeFromAddress = (address?: string) => {
  return (address || '').replace(REGEXPS.AddressPostalCode, '');
};
